import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import dt from '../../../shared/theme';
import CommentForm from './comment-form';
import Comment from './comment';
import { Notice } from './styles';
import { propTypes } from './prop-types';

const Container = styled.div`
  flex-shrink: 0;
  margin-top: 40px;
  margin-bottom: 30px;
  display: flex;
  flex-direction: column;

  & > * {
    width: 100%;
  }
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  & > span {
    font: ${props => dt(props).theme.fontWeightHeavy} 19px/22.8px ${props => dt(props).theme.fontFamilyBody};
    text-transform: uppercase;
  }

  & > .fa-chevron-up {
    font-size: 14px;
    color: ${props => dt(props).theme.secondaryColor};
  }
`;

const MobileVariant = React.forwardRef(({
  isCurrentUserConfirmed,
  wireSlug,
  showCommentLikeHint,
  comments,
  onHeaderClicked,
}, ref) => {
  const isUserSignedIn = !!_.get(window, 'Livewire.currentUser.id');
  const notice = isUserSignedIn
    ? ('Your account currently has restricted access. '
      + 'Please check your email and click the email confirmation link to be '
      + 'able to post comments.')
    : 'Please sign in to comment on this wire.';

  return (
    <Container ref={ref}>
      <Header onClick={() => onHeaderClicked && onHeaderClicked()}>
        <span>comments</span>
        <i className="fa fa-chevron-up" />
      </Header>
      {
        (isUserSignedIn && isCurrentUserConfirmed)
          ? <CommentForm wireSlug={wireSlug} />
          : <Notice>{notice}</Notice>
      }
      {comments.map((c, i) => (
        <Comment
          {...c}
          key={c.id}
          wireSlug={wireSlug}
          isFirstComment={i === 0}
          showCommentLikeHint={showCommentLikeHint}
        />
      ))}
    </Container>
  );
});

MobileVariant.propTypes = {
  wireSlug: PropTypes.string.isRequired,
  isCurrentUserConfirmed: PropTypes.bool.isRequired,
  showCommentLikeHint: PropTypes.bool.isRequired,
  comments: PropTypes.arrayOf(PropTypes.shape(propTypes)).isRequired,
  onHeaderClicked: PropTypes.func,
};

MobileVariant.defaultProps = { onHeaderClicked: null };

MobileVariant.displayName = 'MobileVariant';

export default MobileVariant;
